import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const fetchTauroPackages = async () => {
  const { data } = await axios.get(`${API}/tauro/packages`);
  return data;
};

export const checkoutTauro = async (package_id) => {
  const { data } = await axios.post(`${API}/tauro/checkout`, { package_id });
  return data;
};

export const tauroChat = async (message, session_id) => {
  const { data } = await axios.post(`${API}/tauro/chat`, { message, session_id });
  return data;
};

export const tauroAnalyze = async (lottery, play_type, context) => {
  const { data } = await axios.post(`${API}/tauro/analyze`, { lottery, play_type, context });
  return data;
};

export const fetchTauroHistory = async () => {
  const { data } = await axios.get(`${API}/tauro/history`);
  return data;
};
